import React from "react";
import styles from "./FileListPreloader.module.scss";

const FileListPreloader = () => {
  return <div className={styles.preloader} />;
};

export default FileListPreloader;
